import Link from '@/components/Link';
import TrainerListingAction from './TrainerListingAction';

export default function TrainerListingActions({ uri, social: { linkedin } }) {
  const hasLinkedIn = linkedin !== null;

  return (
    <div className="border-t border-gray-200 flex items-center divide-x">
      {hasLinkedIn && (
        <TrainerListingAction
          url={linkedin}
          className="rounded-bl-lg lg:rounded-bl-xl xl:rounded-bl-2xl"
        >
          LinkedIn
        </TrainerListingAction>
      )}
      <TrainerListingAction
        url={uri}
        className="rounded-br-lg lg:rounded-br-xl xl:rounded-br-2xl"
      >
        Ver perfil
      </TrainerListingAction>
    </div>
  );
}
